import PropTypes from 'prop-types';
import GlossaryText from '../GlossaryText';
import ImageVideo from '../ImageVideo';
import RawHtml from '../RawHtml/RawHtml';
import styles from './TwoColumnModule.module.scss';

const TwoColumnModule = ({ columns = [] }) => {
    if (!columns.length) {
        return null;
    }

    return (
        <div className={styles['TwoColumnModule']}>
            {columns.map((column, index) => (
                <div key={index} className={styles['TwoColumnModule__Column']}>
                    {!!column.title && (
                        <h3 className={styles['TwoColumnModule__Title']}>
                            <GlossaryText text={column.title} />
                        </h3>
                    )}
                    {column.media ? (
                        <ImageVideo {...column.media} />
                    ) : (
                        !!column.richText && (
                            <div className={styles['TwoColumnModule__Text']}>
                                <RawHtml html={column.richText} />
                            </div>
                        )
                    )}
                </div>
            ))}
        </div>
    );
};

TwoColumnModule.propTypes = {
    columns: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            richText: PropTypes.string,
            media: PropTypes.object,
        })
    ),
};

export default TwoColumnModule;
